import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-type-array",
  "use": "icon-type-array-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-type-array\"><path d=\"M28 4.01v24.017h-6.001v-1.958h4.094V6.002h-4.094V4.01zm-24.001 0v24.017H10v-1.958H5.906V6.002H10V4.01z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol